<template>
  <div class="auth-content">
    <div class="auth-content_title">{{titleText}}</div>
    <div class="auth-content_main">
      <h5 class="auth-content_tips" v-if="isBindContact">{{bindTips}}</h5>
      <popup-selector
        show-icon
        v-if="authType==='mobile'&&!isBindContact"
        :icon="locationIcon"
        class="popup-selector"
        @show-popup="pickerShow = true"
        icon-style="flex: 0 0 14px;width: 14px;height: 23px;background-size: 100% 100%;"
      >
        <span class="location-name">{{curLocation.name || '請選擇國別碼'}}</span>
      </popup-selector>
      <pl-input
        type="tel"
        v-model="phone"
        class="auth-content_input"
        placeholder="請輸入手機號碼"
        v-datain="{ext3: '输入手机号'}"
        key="phoneNumber"
        v-if="authType==='mobile'&&!isBindContact"
      >
        <template #suffix>
          <i class="input-icon_phone"></i>
        </template>
      </pl-input>
      <pl-input
        type="email"
        v-model="email"
        class="auth-content_input"
        placeholder="請輸入郵箱地址"
        v-datain="{ext3: '输入邮箱地址'}"
        key="emailAddress"
        v-if="authType==='email'&&!isBindContact"
      >
        <template #suffix>
          <i class="input-icon_email"></i>
        </template>
      </pl-input>
      <pl-input
        class="auth-content_input"
        v-model="authCode"
        placeholder="請輸入驗證碼"
        :key="authType"
        v-datain="{ext3: authType === 'mobile' ? '输入手机验证码': '输入邮箱验证码'}"
      >
        <template #suffix>
          <i class="input-icon_code"></i>
        </template>
        <template #prefix>
          <span
            @click.stop.prevent="sendCode"
            class="input-btn_send j-send-code-dcount"
          >{{codeText}}</span>
        </template>
      </pl-input>
      <div
        @click="handleClick"
        class="auth-confirm_btn j-auth-confirm-dcount"
        :class="!isBindContact && authType === 'mobile' ? 'not-bind' : false"
      >{{btnText}}</div>
      <div class="auth-content_type" v-if="!isBindContact">
        <div>
          <span class="auth-content_type-tips">其他驗證方式</span>
        </div>
        <div class="auth-content_type-btn j-auth-type-dcount" @click.stop.prevent="changeAuthType">
          <i
            class="auth-content_type-icon j-auth-type-dcount"
            :class="authType === 'mobile' ? 'email' : 'mobile'"
          ></i>
          {{authTypeText}}
        </div>
      </div>
    </div>
    <popup-picker
      :list="list"
      v-if="pickerShow"
      title="國別碼列表"
      @select="pickerSelect"
      class="auth-content_picker"
      @close="pickerShow = false"
    ></popup-picker>
    <div class="password-input_mask" v-if="showPassword" @click="showPassword = false">
      <password-input
        ref="passwordInput"
        :title="passwordTitle"
        @complete="completePWD"
        @close="showPassword = false"
        class="password-input_content"
      ></password-input>
    </div>
    <div class="points-jump_mask" v-if="showPointsJump">
      <div class="points-jump_content">
        <h4 class="points-jump_title">密碼設置成功</h4>
        <p class="points-jump_text">即將自動跳轉至商品選擇頁</p>
        <div class="points-jump_button" @click="jumpToProduct">跳轉至商品頁</div>
      </div>
    </div>
  </div>
</template>

<script>
import phoneList from '@/utils/phone'
import viewport from '@/mixins/viewport'
import plInput from '@/components/pl-input'
import locationIcon from '@/assets/location.png'
import passwordInput from '@/components/password'
import popupPicker from '@/components/popup-picker'
import popupSelector from '@/components/popup-selector'
import { encryption, getHrefParamFromLocation as getParams } from '@/utils'
export default {
  name: 'Authentication',
  mixins: [viewport],
  components: { plInput, popupPicker, popupSelector, passwordInput },
  data () {
    return {
      locationIcon,
      authType: 'mobile',
      // 是否绑定联系方式
      isBindContact: false,
      time: 0,
      timmer: null,
      phone: '',
      email: '',
      authCode: '',
      pickerShow: false,
      curLocation: {},
      list: [],
      token: '',
      showPassword: false,
      inputTime: 'first',
      password: {},
      passwordTitle: '請輸入二級密碼',
      passwordError: false,
      // 跳轉舊儲值頁平台幣
      showPointsJump: false
    }
  },
  computed: {
    titleText () {
      let obj = {
        mobile: '手機驗證',
        email: '郵箱驗證'
      }
      return obj[this.authType]
    },
    bindTips () {
      let str = `您已綁定${this.authType === 'mobile' ? '手機' : '郵箱'}${
        this.$route.query.contact
      }，請進行認證`
      return str
    },
    codeText () {
      if (this.time) {
        return `${this.time}S`
      }
      return '發送'
    },
    btnText () {
      return '確認提交'
    },
    authTypeText () {
      let obj = {
        mobile: '郵箱驗證',
        email: '手機驗證'
      }
      return obj[this.authType]
    },
    showTips () {
      return this.$store.getters.getShowTips
    },
    isPortrait () {
      return this.$store.getters.getDeviceDirection
    }
  },
  watch: {
    showTips (show) {
      if (show) {
        return
      }
      if (this.passwordError) {
        this.showPassword = true
        this.passwordError = false
        this.inputTime = 'first'
        this.passwordTitle = '請輸入二級密碼'
      }
    },
    isPortrait () {
      this.$nextTick(() => {
        this.initViewport()
      })
    }
  },
  methods: {
    showTipsContent (content) {
      this.$store.commit('setTipsState', true)
      this.$store.commit('setTipsContent', content)
    },
    sendCode () {
      if (this.time) {
        return
      }
      if (this.authType === 'mobile' && !this.isBindContact) {
        if (!this.curLocation.value) {
          this.showTipsContent('請選擇國別碼')
          return
        }
        if (!this.phone) {
          this.showTipsContent('請填寫手機門號')
          return
        }
      } else if (this.authType === 'email' && !this.isBindContact) {
        if (!this.email) {
          this.showTipsContent('請填寫郵箱地址')
          return
        }
      }
      this.$datain({
        ext3: this.authType === 'mobile' ? '发送手机验证码' : '发送邮箱验证码'
      })
      this.sendAuthCode()
      let waitTime = () => {
        this.time--
        if (this.time <= 0) {
          clearInterval(this.timmer)
        }
      }
      this.time = 120
      this.timmer = setInterval(waitTime, 1000)
    },
    sendAuthCode () {
      let urlObj = {
        mobile: '//passport.gm99.com/center/verify_phone/send',
        email: '//passport.gm99.com/center/verify_email/send'
      }
      let params = {}
      let isBind = this.isBindContact
      if (this.authType === 'mobile') {
        if (isBind) {
          params = {
            ref: 'secondary_password'
          }
        } else {
          params = {
            act: 'secondary_password',
            phone_code: this.curLocation.value || '',
            phone: this.phone
          }
        }
      } else {
        if (isBind) {
          params = {
            ref: 'secondary_password'
          }
        } else {
          params = {
            ref: 'set',
            email: this.email
          }
        }
      }
      this.$jsonp(urlObj[this.authType], params)
        .then(res => {
          if (+res.result === 1) {
            if (this.authType === 'email' && !this.isBindContact) {
              this.token = res.data.token
            }
            this.showTipsContent('驗證碼發送成功，請查收')
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    handleClick () {
      this.$datain({ ext3: '提交验证' })
      if (this.isBindContact) {
        this.handleConfirm()
      } else {
        this.setContact()
      }
    },
    handleConfirm () {
      let urlObj = {
        mobile: '//passport.gm99.com/center/verify_phone/verify',
        email: '//passport.gm99.com/center/verify_email/verify'
      }
      let params = {
        ref: 'secondary_password',
        step: 'last'
      }
      if (this.authType === 'mobile') {
        params.valid_code = this.authCode
      } else {
        params.email_verify_token = this.authCode
      }
      this.$jsonp(urlObj[this.authType], params)
        .then(res => {
          if (+res.result === 1) {
            this.handlePassword(res.data)
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    setContact () {
      let urlObj = {
        mobile: '//passport.gm99.com/center/verify_phone/set',
        email: '//passport.gm99.com/center/verify_email/set'
      }
      let params = {}
      if (this.authType === 'mobile') {
        params = {
          phone_code: this.curLocation.value,
          phone: this.phone,
          valid_code: this.authCode
        }
      } else {
        params = {
          ref: 'set',
          token: this.token,
          email_verify_token: this.authCode
        }
      }
      this.$jsonp(urlObj[this.authType], params)
        .then(res => {
          if (+res.result === 1) {
            this.handlePassword(res.data)
          } else {
            this.$datain({ ext3: '設置聯繫方式失敗', ext13: res.msg })
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    handlePassword (data) {
      this.token = data.MODIFY_TOKEN || this.token
      this.showPassword = true
      this.inputTime = 'first'
    },
    changeAuthType () {
      let obj = {
        mobile: 'email',
        email: 'mobile'
      }
      this.resetValue()
      this.authType = obj[this.authType]
      this.$datain({ ext3: '切换验证方式' })
    },
    resetValue () {
      this.phone = ''
      this.email = ''
      this.authCode = ''
      this.curLocation = {}
    },
    pickerSelect (data) {
      this.curLocation = data
      try {
        this.$datain({ ext3: '选择国别码' })
        window.sdkBehave.push({
          event: '選擇國別碼',
          type: 'gm_wallet',
          gaEventName: 'selectCountryCode'
        })
      } catch (e) {}
    },
    completePWD (pwd) {
      if (this.inputTime === 'first') {
        this.passwordTitle = '請確認二級密碼'
        this.password[this.inputTime] = pwd.trim()
        this.$refs.passwordInput.clearPWD()
        this.inputTime = 'second'
        this.$datain({ ext3: '设置二级密码' })
        this.$nextTick(() => {
          this.$refs.passwordInput.focus()
        })
        return
      }
      if (this.inputTime === 'second') {
        this.password[this.inputTime] = pwd.trim()
        this.setPayPassword()
        this.$datain({ ext3: '确认二级密码' })
        try {
          window.sdkBehave.push({
            event: '設置二級密碼',
            type: 'gm_wallet',
            gaEventName: 'setSecondPassword'
          })
        } catch (e) {}
      }
    },
    jumpToProduct () {
      // 優先跳轉fromUrl（舊版儲值頁）
      window.location.href = getParams('fromUrl')
        ? this.$route.query.fromUrl
        : '//mstore.gm99.com'
    },
    setPayPassword () {
      let params = {
        ref: 'secondary_password',
        modify_token: this.token,
        secondary_password: encodeURIComponent(encryption(this.password.first)),
        confirm_secondary_password: encodeURIComponent(
          encryption(this.password.second)
        )
      }
      this.inputTime = 'first'
      this.password = {}
      this.$jsonp('//passport.gm99.com/center/secondary_password/set', params)
        .then(res => {
          if (+res.result === 1) {
            this.showPassword = false
            // this.showTipsContent('密碼設置成功')
            this.showPointsJump = true
            setTimeout(() => {
              // this.$store.commit('setTipsState', false)
              if (getParams('fromUrl')) {
                // 優先跳轉fromUrl（舊版儲值頁）
                window.location.href = this.$route.query.fromUrl
              } else if (getParams('from') === 'Channel') {
                let search = window.sessionStorage.getItem('search')
                window.location.href =
                  process.env.NODE_ENV === 'development'
                    ? `//zero.gm99.com:8080/channel.html${search}`
                    : `//mstore.gm99.com/points/pay${search}`
              } else if (getParams('from') === 'order') {
                this.$router.push({
                  name: 'order',
                  query: JSON.parse(this.$route.query.old)
                })
              } else if (getParams('from') === 'channelPay') {
                this.$router.push({
                  name: 'channelPay',
                  query: JSON.parse(this.$route.query.old)
                })
              }
            }, 500)
          } else {
            this.showPassword = false
            this.passwordError = true
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    }
  },
  created () {
    let authType = getParams('authType')
    if (authType) {
      this.authType = authType
    }
    this.isBindContact = !!+getParams('isBind')
    if (!this.isBindContact) {
      this.list = phoneList.map(item => {
        item.id = item.name
        item.value = item.code
        return item
      })
    }
  },
  mounted () {
    this.initViewport()
  },
  beforeDestroy () {
    this.removeViewport()
  }
}
</script>

<style lang="scss" scoped>
%input-icon {
  width: 14px;
  height: 23px;
  margin-right: 14px;
  display: inline-block;
  vertical-align: baseline;
  background-size: 100% 100%;
}
.popup-selector {
  height: 44px;
  text-align: left;
  padding: 10px 15px;
  .location-name {
    font-size: 13px;
    color: #9c9c9c;
    padding-left: 4px;
  }
}
.auth-content {
  width: 341px;
  min-height: 296px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 1px 1px 5px #ededed;
  &_title {
    height: 40px;
    color: #333;
    font-size: 15px;
    font-weight: 700;
    line-height: 40px;
    box-sizing: border-box;
    border-bottom: 1px solid #ededed;
  }
  &_tips {
    margin: 0;
    padding-top: 6px;
    padding-bottom: 28px;
  }
  &_main {
    padding: 17px 12px;
  }
  &_input {
    margin-top: 10px;
  }
  &_type {
    font-size: 13px;
    margin-top: 43px;
    color: #9c9c9c;
    &-tips {
      position: relative;
      &:before,
      &:after {
        top: 50%;
        height: 0;
        width: 38px;
        content: " ";
        position: absolute;
        border-bottom: 1px solid #9c9c9c;
        transform: translate3d(0, -50%, 0);
        transform: translate(0, -50%) \9;
      }
      &:before {
        left: -48px;
      }
      &:after {
        right: -48px;
      }
    }
    &-icon {
      width: 14px;
      height: 13px;
      display: inline-block;
      background-size: 100% 100%;
      vertical-align: text-bottom;
      &.mobile {
        background-image: url(../assets/phone.png);
      }
      &.email {
        background-image: url(../assets/email.png);
      }
    }
    &-btn {
      cursor: pointer;
      font-size: 13px;
      margin-top: 12px;
      color: #e97d30;
      padding-bottom: 2px;
      display: inline-block;
      border-bottom: 1px solid #e97d30;
    }
  }
  &_picker {
    text-align: left;
  }
  .auth-confirm_btn {
    width: 141px;
    height: 35px;
    color: #fff;
    margin: 0 auto;
    cursor: pointer;
    font-size: 18px;
    margin-top: 78px;
    line-height: 35px;
    text-align: center;
    border-radius: 18px;
    background: #e97d30;
    background: linear-gradient(120deg, #ffad37, #ff8008) #ff8008;
    &.not-bind {
      margin-top: 34px;
    }
  }
  .input-icon_code {
    @extend %input-icon;
    background-image: url(../assets/code.png);
  }
  .input-icon_phone {
    @extend %input-icon;
    background-image: url(../assets/phone.png);
  }
  .input-icon_email {
    @extend %input-icon;
    width: 19px;
    height: 16px;
    margin-left: -3px;
    margin-right: 12px;
    vertical-align: middle;
    background-image: url(../assets/email.png);
  }
  .input-btn_send {
    top: 50%;
    right: 15px;
    width: 64px;
    height: 28px;
    cursor: pointer;
    color: #e97d30;
    line-height: 28px;
    position: absolute;
    border-radius: 5px;
    text-align: center;
    display: inline-block;
    box-sizing: border-box;
    border: 1px solid #e97d30;
    transform: translate3d(0, -50%, 0);
    transform: translate(0, -50%) \9;
  }
  .password-input {
    &_mask {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.8);
    }
    &_content {
      margin: 30% auto 0;
    }
  }
  .points-jump {
    $color: #f87e19;
    &_mask {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.8);
    }
    &_content {
      top: 50%;
      left: 50%;
      padding: 5px;
      width: 250px;
      height: 200px;
      overflow-y: scroll;
      border-radius: 8px;
      position: absolute;
      background-color: #fff;
      border: 1px solid #f87e19;
      transform: translate(-50%, -50%);
    }
    &_title {
      font-size: 20px;
    }
    &_button {
      width: 115px;
      height: 26px;
      color: #fff;
      font-size: 14px;
      margin-top: 30px;
      line-height: 26px;
      text-align: center;
      border-radius: 13px;
      display: inline-block;
      background-color: $color;
    }
  }
}
@media screen and (orientation: landscape) {
  .popup-selector {
    margin-top: 0;
  }
  .auth-content {
    width: 341px;
    height: 287px;
    min-height: 0;
    &_title {
      display: none;
    }
    &_type {
      margin-top: 5px;
    }
    &_input:first-child {
      margin-top: 24px;
    }
    .auth-confirm_btn {
      margin-top: 50px;
      &.not-bind {
        margin-top: 20px;
      }
    }
    .password-input_content {
      margin: 5% auto 0;
    }
  }
}
</style>
